export const MANUAL_WAKELOOP_UPGRADE_COMMAND = "npm install -g wakeloop@latest";
const SAFE_SHELL_ARGUMENT_PATTERN = /^[A-Za-z0-9_./:@%+=,-]+$/;

export function buildManualWakeLoopUpgradeCommand(
  input: { globalPrefixPath?: string | null } = {}
): string {
  const globalPrefixPath = input.globalPrefixPath?.trim();
  if (!globalPrefixPath) {
    return MANUAL_WAKELOOP_UPGRADE_COMMAND;
  }
  return `npm install -g --prefix ${formatShellArgument(globalPrefixPath)} wakeloop@latest`;
}

export const WAKELOOP_UPGRADE_METADATA_RECOVERY_HINTS = [
  MANUAL_WAKELOOP_UPGRADE_COMMAND,
  "wakeloop reset --yes",
  "wakeloop start",
  "wakeloop upgrade --check",
] as const;

export const WAKELOOP_UPGRADE_FAILURE_HINTS = [
  MANUAL_WAKELOOP_UPGRADE_COMMAND,
  "wakeloop upgrade --check",
  "wakeloop upgrade --yes",
] as const;

function formatShellArgument(value: string): string {
  if (SAFE_SHELL_ARGUMENT_PATTERN.test(value)) {
    return value;
  }
  return JSON.stringify(value);
}
